module.exports = __webpack_public_path__ + "static/dashboard-premium-dark-35af62c336a0641bc34bcd00b6cf3df0.png";